import {
  CheckCircle as CheckCircleIcon,
  Edit as EditIcon,
  Warning as WarningIcon,
  Info as InfoIcon,
} from '@mui/icons-material';

/**
 * Get status color, icon, and label for version status
 */
export const getStatusInfo = status => {
  switch (status) {
    case 'active':
      return { color: 'success', icon: <CheckCircleIcon />, label: 'Active' };
    case 'draft':
      return { color: 'warning', icon: <EditIcon />, label: 'Draft' };
    case 'deprecated':
      return { color: 'error', icon: <WarningIcon />, label: 'Deprecated' };
    case 'archived':
      return { color: 'default', icon: <InfoIcon />, label: 'Archived' };
    default:
      return { color: 'default', icon: <InfoIcon />, label: status };
  }
};

/**
 * Get version number from version string
 * Extracts "1.0.0" from "1.0.0 (Active)"
 */
export const getVersionNumber = version => {
  return version.split(' ')[0];
};

/**
 * Format date for display
 */
export const formatDate = dateString => {
  return new Date(dateString).toLocaleDateString();
};
